import Address from "../models/Address";

export const IsValidAddress = (address:Address) => {
    return !address.address || !address.number || !address.county || !address.city ||
    !address.state ? false : true;
}